import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ProgressModel} from 'src/app/services/models/progress.model';
import {UserInfoModel} from 'src/app/services/models/user-info.model';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-coach-home',
    templateUrl: './coach-home.component.html',
    styleUrls: ['./coach-home.component.scss']
})
export class CoachHomeComponent implements OnInit {
    environment = null;
    menuVisible = true;

    @Input() userInfo: UserInfoModel = null;
    @Input() progress: ProgressModel = null;

    constructor(
        private router: Router,
        public userService: UserService,
    ) {
    }

    ngOnInit() {
    }
}

